/**
 * ⭐⭐⭐ **Nama tamu bawaan `guest_01`, `guest_02`, …** (Imron, 2026-08-25: *"di mode quick service
 * beri default nama tamu guest_xx. xx diisi urut. ini untuk kecepatan kasir saja tanpa perlu repot
 * ketik nama."*).
 *
 * ### ⛔ Kenapa BUKAN memakai nomor bill
 * Nomor bill (`HP_KASIR/260825/007`) sudah ada dan berurut — tapi ia tak pernah diucapkan siapa
 * pun. Yang dibutuhkan juru masak & tamu adalah sesuatu yang bisa DITERIAKKAN, dan "guest 7" bisa;
 * "HP_KASIR garis miring dua enam nol delapan dua lima" tidak. Itu persis kegagalan K31 yang sudah
 * terjadi sekali di KDS PB-PKB.
 *
 * ### ⚠️ Ini KENYAMANAN, bukan identitas
 * ⛔ Tak ada apa pun yang menjamin keunikannya lintas perangkat — dua till bisa sama-sama punya
 * `guest_03` di hari yang sama. Yang menjamin keunikan tetap nomor bill (K13/§4b). Menjadikannya
 * identitas berarti dua tumpukan piring berjudul sama di dapur.
 *
 * ⭐ Karena itu ia diulang dari 1 tiap **hari usaha**: nomor yang terus naik sampai `guest_438`
 * berhenti bisa diteriakkan, dan itu satu-satunya gunanya.
 */
const KEY = 'osbpos.guestSeq';

interface Tersimpan {
  readonly day: string;
  readonly seq: number;
}

function baca(): Tersimpan | null {
  try {
    const v = globalThis.localStorage?.getItem(KEY);
    if (v === null || v === undefined) return null;
    const o = JSON.parse(v) as Partial<Tersimpan>;
    return typeof o.day === 'string' && typeof o.seq === 'number' ? { day: o.day, seq: o.seq } : null;
  } catch {
    /* ⚠️ Penyimpanan yang tak bisa dibaca (mode privat, kuota penuh) TIDAK boleh menjatuhkan
       layar kasir — ia cuma berarti nomornya mulai dari 1 lagi. */
    return null;
  }
}

function tulis(v: Tersimpan): void {
  try {
    globalThis.localStorage?.setItem(KEY, JSON.stringify(v));
  } catch {
    /* Sama: gagal menyimpan berarti nomor berikutnya mengulang, bukan kasir yang terhenti. */
  }
}

/**
 * Nomor tamu berikutnya untuk hari usaha ini — **tanpa mengambilnya**.
 *
 * ⛔ Sengaja tak menaikkan pencacah: dialog penanda bisa dibuka lalu DIBATALKAN, dan nomor yang
 * terbakar tiap kali dialog dilihat membuat urutannya bolong-bolong tanpa ada tamu yang hilang.
 */
export function peekGuestName(businessDate: string): string {
  const lama = baca();
  const seq = lama !== null && lama.day === businessDate ? lama.seq + 1 : 1;
  return `guest_${String(seq).padStart(2, '0')}`;
}

/**
 * Menandai bahwa nama tamu bawaan BENAR-BENAR dipakai ⇒ nomor berikutnya naik.
 *
 * ⚠️ Dipanggil hanya saat penandanya disimpan, dan hanya bila labelnya masih persis nama bawaan.
 * Kasir yang mengetik "Bu Rina" tak menghabiskan nomor — kalau tidak, urutannya melompat-lompat
 * dan "guest_12" muncul sebagai tamu kedua hari itu.
 */
export function commitGuestName(businessDate: string, label: string): void {
  const lama = baca();
  const seq = lama !== null && lama.day === businessDate ? lama.seq + 1 : 1;
  if (label !== `guest_${String(seq).padStart(2, '0')}`) return;
  tulis({ day: businessDate, seq });
}
